module.exports = {
    close: {
        en: "Close",
        fi: "Sulje"
    },
    updateFiles: {
        en: "Update files",
        fi: "Päivitä tiedostot"
    },
    uploadImages: {
        en: "Upload images",
        fi: "Lisää kuvia"
    },
    uploadImagesToolTip: {
        en: "At least one image is required",
        fi: "Vähintään yksi kuva on pakollinen"
    },
    uploadVideos: {
        en: "Upload videos",
        fi: "Lisää videoita tietokoneelta"
    },
    uploadVideosToolTip: {
        en: "Video is optional",
        fi: "Video on valinnainen"
    },
    status: {
        en: "Status",
        fi: "Tila"
    },
    selectAStatus: {
        en: "Select a status",
        fi: "Valitse tila"
    },
    selectAStatusToolTip: {
        en: "Status is required",
        fi: "Tila on pakollinen"
    },
    sold: {
        en: "Sold",
        fi: "Myyty"
    },
    selling: {
        en: "Selling",
        fi: "Myydään"
    },
    cancel: {
        en: "Cancel",
        fi: "Peruuta"
    },
    basicInfo: {
        en: "Basic info",
        fi: "Perustiedot"
    },
    title: {
        en: "Title",
        fi: "Otsikko"
    },
    titlePlaceholder: {
        en: "Title here",
        fi: "Otsikko tähän"
    },
    titleToolTip: {
        en: "Title is required",
        fi: "Otsikko on pakollinen"
    },
    description: {
        en: "Description",
        fi: "Tekstikuvailu"
    },
    descriptionPlaceholder: {
        en: "Description here",
        fi: "Kuvaus tähän"
    },
    descriptionToolTip: {
        en: "Description is optional",
        fi: "Tekstikuvaus on pakollinen"
    },
    price: {
        en: "Price in €",
        fi: "Hinta €"
    },
    pricePlaceholder: {
        en: "Price in € here",
        fi: "Hinta € tähän"
    },
    priceToolTip: {
        en: "Price is required",
        fi: "Hinta on pakollinen"
    },
    selectAType: {
        en: "Select a type",
        fi: "Valitse tyyppi"
    },
    selectATypeToolTip: {
        en: "Type is required",
        fi: "Tyyppi on pakollinen"
    },
    selectASubType: {
        en: "Select a sub type",
        fi: "Valitse alityyppi"
    },
    selectASubTypeToolTip: {
        en: "Sub type is required",
        fi: "Alatyyppi on pakollinen"
    },
    selectAMaker: {
        en: "Select a maker",
        fi: "Valitse valmistaja"
    },
    selectAMakerToolTip: {
        en: "Maker is required",
        fi: "Valmistaja on pakollinen"
    },
    otherMakerName: {
        en: "Other maker name",
        fi: "Toinen valmistajan nimi"
    },
    otherMakerNamePlaceholder: {
        en: "Maker name",
        fi: "Valmistajan nimi"
    },
    otherMakerNameToolTip: {
        en: "Other maker name is required",
        fi: "Toisen valmistajan nimi on pakollinen"
    },
    selectACondition: {
        en: "Select a condition",
        fi: "Valitse kuntotaso"
    },
    selectAConditionToolTip: {
        en: "Condition is required",
        fi: "Kuntotaso on pakollinen"
    },
    locationInfo: {
        en: "Location info",
        fi: "Sijainti"
    },
    selectAProvince: {
        en: "Select a province",
        fi: "Valitse maakunta"
    },
    selectAProvinceToolTip: {
        en: "Province is required",
        fi: "Maakunta on pakollinen"
    },
    selectACity: {
        en: "Select a city",
        fi: "Valitse kaupunki"
    },
    selectACityToolTip: {
        en: "City is required",
        fi: "Kaupunki on pakollinen"
    },
    moreInfo: {
        en: "More info",
        fi: "Lisätietoa"
    },
    selectAFrameSize: {
        en: "Select a frame size",
        fi: "Valitse rungon koko"
    },
    selectAFrameSizeToolTip: {
        en: "Frame size in inches is optional",
        fi: "Runkokoko tuumina on valinnainen"
    },
    selectAGear: {
        en: "Select a gear",
        fi: "Valitse vaihteisto"
    },
    selectAGearToolTip: {
        en: "Amount of gears is optional",
        fi: "Vaihteiden lukumäärä on valinnainen"
    },
    selectATyreType: {
        en: "Select a tyre type",
        fi: "Valitse renkaiden tyyppi"
    },
    selectATyreTypeToolTip: {
        en: "Tyre type is optional",
        fi: "Renkaiden tyyppi on valinnainen"
    },
    selectAMaterial: {
        en: "Select a material",
        fi: "Valitse materiaali"
    },
    selectAMaterialToolTip: {
        en: "Material used is optional",
        fi: "Materiaali on valinnainen"
    },
    selectABreakType: {
        en: "Select a break type",
        fi: "Valitse jarrujen tyyppi"
    },
    selectABreakTypeToolTip: {
        en: "Break type is optional",
        fi: "Jarrujen tyyppi on valinnainen"
    },
    selectASuspensionType: {
        en: "Select a suspension type",
        fi: "Valitse jousituksen tyyppi"
    },
    selectASuspensionTypeToolTip: {
        en: "Suspension type is optional",
        fi: "Jousituksen tyyppi on valinnainen"
    },
    selectAGender: {
        en: "Select a gender",
        fi: "Valitse sukupuoli"
    },
    selectAGenderToolTip: {
        en: "Gender is optional",
        fi: "Sukupuoli on valinnainen"
    },
    selectANumOfWheels: {
        en: "Select a number of wheels",
        fi: "Valitse renkaiden määrä"
    },
    selectANumOfWheelsToolTip: {
        en: "Number of wheels is optional",
        fi: "Renkaiden lukumäärä on valinnainen"
    },
    selectAWheelSize: {
        en: "Select a wheel size",
        fi: "Valtise renkaiden koko"
    },
    selectAWheelSizeToolTip: {
        en: "Wheel size is optional",
        fi: "Renkaiden koko on valinnainen"
    },
    selectAMudGuardType: {
        en: "Select a mud guard type",
        fi: "Valitse lokasuojan tyyppi"
    },
    selectAMudGuardTypeToolTip: {
        en: "Mud guard type is optional",
        fi: "Lokasuojan tyyppi on valinnainen"
    },
    selectARackType: {
        en: "Select a rack type",
        fi: "Valitse tarakan tyyppi"
    },
    selectARackTypeToolTip: {
        en: "Rack type is optional",
        fi: "Tarakan tyyppi on valinnainen"
    },
    selectABasketType: {
        en: "Select a basket type",
        fi: "Valitse korin tyyppi"
    },
    selectABasketTypeToolTip: {
        en: "Basket type is optional",
        fi: "Korin tyyppi on valinnainen"
    },
    isLockIncluded: {
        en: "Is lock included",
        fi: "Sisältyykö lukko kauppaan"
    },
    isLockIncludedToolTip: {
        en: "Lock is optional",
        fi: "Lukko on valinnainen"
    },
    isFrontLightIncluded: {
        en: "Is front light included",
        fi: "Sisältyykö etuvalo kauppaan"
    },
    isFrontLightIncludedToolTip: {
        en: "Front light is optional",
        fi: "Etuvalo on valinnainen"
    },
    isRareLightIncluded: {
        en: "Is rare light included",
        fi: "Sisältyykö takavalo kauppaan"
    },
    isRareLightIncludedToolTip: {
        en: "Rare light is optional",
        fi: "Takavalo on valinnainen"
    },
    legStandExist: {
        en: "Leg stand exists",
        fi: "Pyöränjalka"
    },
    legStandExistToolTip: {
        en: "Leg stand is optional",
        fi: "Pyränjalka ei ole pakollinen"
    },
    submit: {
        en: "Submit",
        fi: "Lähetä"
    },
    yes: {
        en: "Yes",
        fi: "Kyllä"
    },
    no: {
        en: "No",
        fi: "Ei"
    },
    notSure: {
        en: "Not sure",
        fi: "En ole varma"
    },
    notAllowed: {
        en: "Not allowed",
        fi: "Ei sallittu"
    },
    edit: {
        en: "Edit",
        fi: "Muokkaa"
    }
};